import { NavLink } from "react-router-dom";
import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";
import Delete from "../Modals/delete";
import { useState } from "react";
import { connect } from "react-redux";
import { deleteOutreach } from "../../stores/actions/outreach.actions.types";

const OutreachTable = ({ outreaches, deleteOutreach, setOutreaches }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [outreachId, setOutreachId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDelete = async () => {
    setDeleteLoading(true);
    const callback = (data) => {
      if (data.success) {
        setOutreaches((prev) =>
          prev.filter((outreach) => outreach._id !== outreachId)
        );
        setDeleteLoading(false);
        setIsModalOpen(false);
      } else {
        setDeleteLoading(false);
      }
    };
    let request = {
      id: outreachId,
      callback,
    };
    deleteOutreach(request);
  };

  const handleDeleteClick = (id) => {
    setOutreachId(id);
    setIsModalOpen(true);
  };

  return (
    <div className='rounded-[10px] bg-white drop-shadow-1 border-l border-slate-300 dark:border-slate-700 dark:bg-boxdark dark:drop-shadow-none border border-stroke p-4 sm:p-2.5 transition-colors duration-300'>
      <div className='max-w-full overflow-x-auto overflow-y-hidden pb-4'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left dark:bg-dark-2 transition-colors duration-300'>
              <th className='px-4 py-2 font-medium text-dark dark:text-white'>
                Company
              </th>
              <th className='px-4 py-2 font-medium text-dark dark:text-white'>
                Name
              </th>
              <th className='px-4 py-2 font-medium text-dark dark:text-white'>
                Email
              </th>
              <th className='px-4 py-2 font-medium text-dark dark:text-white'>
                Phone
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Created At
              </th>

              <th className='min-w-[30px] px-4 py-2 font-medium text-dark dark:text-white xl:pr-7.5'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {outreaches?.map((outreach, index) => (
              <tr key={outreach._id} className='text-sm'>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === outreaches?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-black dark:text-white'>
                    {outreach.companyName}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === outreaches?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-black dark:text-white'>
                    {outreach.name}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === outreaches?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-black dark:text-white'>
                    {outreach.email}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === outreaches?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-black dark:text-white'>
                    {outreach.phone}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === outreaches?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {new Date(outreach.createdAt).toLocaleDateString()}
                  </h5>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === outreaches?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <div className='flex items-center space-x-3.5'>
                    {/* Details button */}
                    <div className='group relative'>
                      <NavLink to={`/outreach/details/${outreach._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEye className='text-lg' />
                        </button>
                      </NavLink>
                      <span className='absolute left-1/2 top-full w-[60px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white text-center'>
                        Details
                      </span>
                    </div>

                    {/* Update button */}
                    <div className='group relative'>
                      <NavLink to={`/outreach/update/${outreach._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEdit />
                        </button>
                      </NavLink>
                      <span className='absolute left-1/2 top-full w-[60px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white text-center'>
                        Update
                      </span>
                    </div>

                    {/* Delete button */}
                    <div className='group relative'>
                      <button
                        className='mt-[7px] hover:text-primary'
                        onClick={() => handleDeleteClick(outreach._id)}
                      >
                        <FiTrash2 className='text-lg' />
                      </button>
                      <span className='absolute left-1/2 top-full w-[60px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white text-center'>
                        Delete
                      </span>
                    </div>

                    <Delete
                      opened={isModalOpen}
                      setOpend={setIsModalOpen}
                      title='Outreach Delete'
                      handleDelete={handleDelete}
                      loading={deleteLoading}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });

export default connect(mapStateToProps, { deleteOutreach })(OutreachTable);
